import { EventGS, EventGSToken } from '../core/EventsGS';
import { WrapperGS } from '../core/WrapperGS';

export class DialogGS extends WrapperGS<HTMLDialogElement>
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === "dialog";
    }

    private readonly _onCloseToken: EventGSToken<Event>;
    private readonly _onCancelToken: EventGSToken<Event>;
    public readonly onClose: EventGS<Event>;
    public readonly onCancel: EventGS<Event>;

    constructor(el: HTMLDialogElement|string)
    {
        super(el);
        this._onCloseToken = new EventGSToken<Event>(() => { this.el.addEventListener('close', e => this._onCloseToken.invoke(e)); });
        this._onCancelToken = new EventGSToken<Event>(() => { this.el.addEventListener('cancel', e => this._onCancelToken.invoke(e)); });
        this.onClose = new EventGS<Event>(this._onCloseToken);
        this.onCancel = new EventGS<Event>(this._onCancelToken);
    }

    public get open() { return this.el.open; }
    public set open(value: boolean) { this.el.open = value; }

    public get returnValue() { return this.el.returnValue; }
    public set returnValue(value: string) { this.el.returnValue = value; }

    public showDialog() { this.el.show(); }
    public showModal() { this.el.showModal(); }
    public close(returnValue?: string) { this.el.close(returnValue); }
}
WrapperGS.ExtendComponentsByHTMLElement(DialogGS);
